import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { HttpErrorResponse } from '@angular/common/http';

export enum AlertPosition {
  topright,
  topcenter,
  center
}
export enum AlertType {
  error,
  warning,
  success
}

@Injectable()
export class AlertService {
  helpTitle: string;
  helpBody: string;

  constructor(private toastr: ToastrService) { }

  // Clear any alerts that are still showing
  public clearAllAlerts() {
    this.toastr.clear();
  }

  public success(message: string, title?: string, delay: number = 2000) {
    this.toastr.success(message, title, { progressBar: true, progressAnimation: 'decreasing', timeOut: delay, easeTime: 500 });
  }

  public error(message: string, title: string = 'Error', useHtml: boolean = false) {
    this.toastr.error(message, title, { enableHtml: useHtml, disableTimeOut: true, easeTime: 500 });
  }

  public errorWithDetails(errorResponse: HttpErrorResponse, message: string, title?: string) {
    if (errorResponse && errorResponse.error) {
      this.error(`${message} ${errorResponse.error.Message}`, title);
      return;
    }

    this.error(message, title);
  }

  public warning(message: string, title: string = 'Warning', delay: number = 5000) {
    this.toastr.warning(message, title, { progressBar: true, progressAnimation: 'decreasing', timeOut: delay, easeTime: 500 });
  }

  public alertPositioned(message: string, type: AlertType, position: AlertPosition = AlertPosition.center, title: string = 'Warning', delay: number = 5000, useHTML: boolean = false) {
    // Defaults the dialog to the middle of the screen
    let pos: string = 'toast-top-right';
    switch (position) {
      case AlertPosition.center:
        pos = 'toast-center-center';
        break;
      case AlertPosition.topcenter:
        pos = 'toast-top-center';
        break;
    }
    switch (type) {
      case AlertType.error:
        this.toastr.error(message, title, { enableHtml: useHTML, positionClass: pos, disableTimeOut: true, easeTime: 500 });
        break;
      case AlertType.warning:
        this.toastr.warning(message, title, { enableHtml: useHTML, positionClass: pos, progressBar: true, progressAnimation: 'decreasing', timeOut: delay, easeTime: 500 });
        break;
      default:
        this.toastr.success(message, title, { enableHtml: useHTML, positionClass: pos, progressBar: true, progressAnimation: 'decreasing', timeOut: delay, easeTime: 500 });
    }
  }

  public info(message: string, title?: string, delay: number = 5000) {
    this.toastr.info(message, title, { progressBar: true, progressAnimation: 'decreasing', timeOut: delay, easeTime: 500 });
  }

  public html(message: string, title?: string, delay: number = 5000) {
    this.toastr.info(message, title, { enableHtml: true, progressBar: true, progressAnimation: 'decreasing', timeOut: delay, easeTime: 500 });
  }

  public htmlError(message: string, title?: string, delay: number = 5000) {
    this.toastr.error(message, title, { enableHtml: true, progressBar: true, progressAnimation: 'decreasing', timeOut: delay, easeTime: 500 });
  }
}
